<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container class="pl-2 pr-2 pb-2 pt-0" fluid>
    <DialogKennzahlen :balance="balance" ref="dlgKennzahlen"></DialogKennzahlen>
    <v-layout justify-end class="hidden-md-and-down">

      <v-flex class="text-xs-left ma-2">
        <div v-if="isFavoriteActive && !isAlertActivated" style="float:left;margin-top: 7px">
          <v-tooltip top>
            <template #activator="ttData1">
              <span v-on="ttData1.on" :text="isAlertActivatedText" class="btnnotificationOff" name="notification"
                    @click="doSetNotification"><font-awesome-icon :icon="['far', 'star']" class="starColor"/></span>
            </template>
            <span>{{ 'BUTT_ADD_FAVOURITE_ADD' | translate}}</span>
          </v-tooltip>
        </div>
        <!-- <div>
           <font-awesome-icon icon="star" class="starColor"/>
           <font-awesome-icon :icon="['far', 'star']" class="starColor"/>
         </div> -->
        <div v-if="isFavoriteActive && isAlertActivated" style="float:left; margin-top: 7px">
          <v-tooltip top>
            <template #activator="ttData2">
              <span v-on="ttData2.on" :text="isAlertActivatedText" class="btnnotificationOn" name="notification"
                    @click="doSetNotification"><font-awesome-icon icon="star" class="starColor"/></span>
            </template>
            <span>{{ 'BUTT_ADD_FAVOURITE_REM' | translate}}</span>
          </v-tooltip>
        </div>
        <span class="title font-weight-thin primary--text ml-2" v-if="data">
           {{sdTitle}}
        </span>
        <BtnSupportJahresabschluss :title="sdTitle" :balance="balance" v-if="!isPeergroup && appendAllowed"></BtnSupportJahresabschluss>

      </v-flex>
    </v-layout>

    <v-layout justify-spacebetween class="hidden-lg-and-up" row wrap>
      <v-flex class="text-xs-left ma-2">
        <div v-if="isFavoriteActive && !isAlertActivated" style="float:left; margin-top: 7px">
          <v-tooltip top>
            <template #activator="ttData1">
              <span v-on="ttData1.on" :text="isAlertActivatedText" class="btnnotificationOff" name="notification"
                    @click="doSetNotification"><font-awesome-icon :icon="['far', 'star']" class="starColor"/></span>
            </template>
            <span>{{ 'BUTT_ADD_FAVOURITE_ADD' | translate}}</span>
          </v-tooltip>
        </div>
        <!-- <div>
           <font-awesome-icon icon="star" class="starColor"/>
           <font-awesome-icon :icon="['far', 'star']" class="starColor"/>
         </div> -->
        <div v-if="isFavoriteActive && isAlertActivated" style="float:left;margin-top: 7px">
          <v-tooltip top>
            <template #activator="ttData2">
              <span v-on="ttData2.on" :text="isAlertActivatedText" class="btnnotificationOn" name="notification"
                    @click="doSetNotification"><font-awesome-icon icon="star" class="starColor"/></span>
            </template>
            <span>{{ 'BUTT_ADD_FAVOURITE_REM' | translate}}</span>
          </v-tooltip>
        </div>
        <span class="subtitle-2 font-weight-bold primary--text ml-2" v-if="data">
           {{sdTitle}}
        </span>
        <BtnSupportJahresabschluss :balance="balance" v-if="!isPeergroup"></BtnSupportJahresabschluss>
      </v-flex>

      <v-card flat color="transparent" class="pa-2">
        <v-layout row>
          <div class="text-xs-center">
            <v-menu :close-on-content-click="false"
                    :nudge-width="200"
                    offset-x
                    max-width="326px"
                    v-model="dimMenu1"
                    left
            >
              <template #activator="{ on: menu }">
                <v-tooltip bottom>
                  <template #activator="{ on: tooltip }">
                    <v-btn
                      color="#004884"
                      small outline
                      class="text-none"
                      v-on="{ ...tooltip, ...menu }"
                    >
                      <v-icon left class="mr-1" small>autorenew</v-icon>
                      {{currentCurrencyName}} / {{currencyDimensionName}}
                    </v-btn>
                  </template>
                  <span>{{'TOOLTIP_CURRENCY' | translate}}</span>
                </v-tooltip>
              </template>
              <v-card max-width="326px" flat>
                <v-card-title class="pt-2" style="background-color: #004884; color:white;height: 40px">
                  {{'TITLE_DIM_SELECTION' | translate}}
                </v-card-title>
                <v-layout wrap justify-center align-center>
                  <v-card class="mt-4" flat>
                    <v-layout wrap justify-center align-center class="px-4">
                      <v-flex xs12>
                        <v-select
                          solo
                          dense
                          item-text="title"
                          item-value="id"
                          v-model="select_currency"
                          :items="itemscurrency"
                          :label="label_select_currency"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          solo
                          dense
                          item-text="name"
                          item-value="id"
                          v-model="select_currency_dimension"
                          :items="itemscurrencydimension"
                          :label="label_select_currency_dimension"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn block small dark color="#004884" class="text-none" @click="updateDimension()">{{'BUTT_OK'
                          | translate}}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-layout>
              </v-card>
            </v-menu>
          </div>
          <v-btn @click="changeWA" small outline color="#004884"
                 class="text-none" v-if="!isPeergroup">
            {{'BUTT_CHANGE_WA' | translate}}
          </v-btn>
          <v-btn @click="addAnchor" small outline color="#004884"
                 class="text-none" v-if="!isPeergroup && hasWA">
            {{'BUTT_TAKE_ANCHORBANK' | translate}}
          </v-btn>
          <v-btn @click="editPeergroup" small outline color="#004884"
                 class="text-none" v-if="isPeergroup">
            {{'BUTT_TAKE_PEERGROUP' | translate}}
          </v-btn>

          <v-btn @click="showSavePeergroupDialog()" small outline color="#004884"
                 class="text-none" v-if="isPeergroup">
            {{'BUTT_SAVE_PEERGROUP' | translate}}
          </v-btn>
          <v-btn @click="closePeergroup" small outline color="#004884"
                 class="text-none" v-if="isPeergroup">
            {{'BUTT_CLOSE_PEERGROUP' | translate}}
          </v-btn>
        </v-layout>
      </v-card>
    </v-layout>
    <v-layout row wrap>
      <v-flex m12>
        <!--<v-btn @click="destroTable" >huhu</v-btn>-->
        <v-tabs
          color="blue"
          dark
          align-with-title
          v-model="tab1"
          name="sdTabPanel"
          slider-color="#8ACAC1"
          @change="onChangeTab"
          class="activetab"
        >
          <v-tab v-for="(tab,i) in tabsArray" v-bind:key="i" class="text-none" :href="'#' + tab.id" :title="'' + tab.tooltip"
                 :disabled="((tab.active === 0))"><!--:tableName="tableName"-->
            <span>{{tab.name}}</span>

            <ButtonDownloadIcon v-if="tab.downloadFileName !== null" :fileName="getFileName(tab.downloadFileName)"
                                :balance="balance"
                                :data="data" :balanceArray="balanceArray" :isPeergroup="isPeergroup"
                                :configExcel="tab.excel"></ButtonDownloadIcon>
          </v-tab>
          <!--
          <v-tab class="text-none" href="#tabStammdaten">{{'TAB_STAMMDATEN' | translate}}
            <ButtonDownloadIcon :fileName="getFileName(fnStammDaten)" ref="tabStammdatenIcon" :balance="balance"
                                :data="data" :balanceArray="balanceArray" :isPeergroup="isPeergroup"
                                :configExcel="configExcelSD"></ButtonDownloadIcon>
          </v-tab>
          <v-tab class="text-none" v-if="showRohbilanz" :disabled="!(!isPeergroup && hasWA)" href="#tabRohbilanz">
            {{'TAB_ROHBILANZ' |translate}}
            <ButtonDownloadIcon :fileName="getFileName(fnRohBilanz)" ref="tabRohbilanzIcon" :balance="balance"
                                :data="data" :balanceArray="balanceArray" :isPeergroup="isPeergroup"
                                :configExcel="configExcelRB"
                                :name="configExcel.btnName"></ButtonDownloadIcon>
          </v-tab>
          <v-tab class="text-none" :disabled="!hasWA" href="#tabStrukturbilanz">{{'TAB_STRUKTURBILANZ' | translate}}
            <ButtonDownloadIcon :fileName="getFileName(fnStrukturBilanz)" ref="tabStrukturbilanzIcon" :balance="balance"
                                :data="data" :balanceArray="balanceArray" :isPeergroup="isPeergroup"
                                :configExcel="configExcelSB"
                                :name="configExcel.btnName"></ButtonDownloadIcon>


          </v-tab>
          <v-tab class="text-none" :disabled="!hasWA" href="#tabKennzahlen">{{'TAB_KENNZAHLEN' | translate}}
            <ButtonDownloadIcon :fileName="getFileName(fnKennzahlen)" ref="tabKennzahlenIcon" :balance="balance"
                                :data="data" :balanceArray="balanceArray" :isPeergroup="isPeergroup"
                                :configExcel="configExcelKZ"
                                :name="configExcel.btnName"></ButtonDownloadIcon>
          </v-tab>
          <v-tab v-if="showBilanzrating" class="text-none"
                 :disabled="(!(!isPeergroup && hasWA)) || isBank || brDisabled" href="#tabBilanzrating">
            {{'TAB_BILANZRATING' |
            translate}}
            <ButtonDownloadIcon :fileName="getFileName(fnBilanzRating)" ref="tabBilanzratingIcon" :balance="balance"
                                :data="data" :balanceArray="balanceArray" :isPeergroup="isPeergroup"
                                :configExcel="configExcelBR"
                                :name="configExcel.btnName"></ButtonDownloadIcon>
          </v-tab>
          <v-tab class="text-none" :disabled="false" href="#tabBankScore" v-if="(!isPeergroup) && isBank">
            {{'TAB_BANKSCORE' | translate}}
            <ButtonDownloadIcon :fileName="getFileName(fnBS)" ref="tabKDFIcon" :balance="balance" :data="data"
                                :balanceArray="balanceArray" :isPeergroup="isPeergroup"
                                :configExcel="configExcelBS"
                                :name="configExcel.btnName"></ButtonDownloadIcon>
          </v-tab>
          <v-tab class="text-none" :disabled="false" href="#tabVerflechtung" v-if="(!isPeergroup) && isBank">
            {{'TAB_VERFLECHTUNG' | translate}}
            <ButtonDownloadIcon :fileName="getFileName(fnVP)" ref="tabKDFIcon" :balance="balance" :data="data"
                                :balanceArray="balanceArray" :isPeergroup="isPeergroup"
                                :configExcel="configExcelVP"
                                :name="configExcel.btnName"></ButtonDownloadIcon>

          </v-tab>
          <v-tab v-if="showKDF" class="text-none" :disabled="(!(!isPeergroup)) || isBank || kdfDisabled" href="#tabKDF">
            {{'TAB_KAPITALDIENSTFAEHIGKEIT' |translate}}
            <ButtonDownloadIcon :fileName="getFileName(fnKDF)" ref="tabKDFIcon" :balance="balance" :data="data"
                                :balanceArray="balanceArray" :isPeergroup="isPeergroup"
                                :configExcel="configExcelKDF"
                                :name="configExcel.btnName"></ButtonDownloadIcon>
          </v-tab>
          <v-tab class="text-none" href="#tabDocuments">{{'TAB_DOKUMENTE' | translate}}</v-tab>
          -->
          <v-spacer></v-spacer>


          <div class="text-xs-center hidden-md-and-down">
            <v-menu :close-on-content-click="false"
                    :nudge-width="200"
                    offset-x
                    max-width="326px"
                    v-model="dimMenu"
                    left
            >
              <template #activator="{ on: menu }">
                <v-tooltip bottom>
                  <template #activator="{ on: tooltip }">
                    <v-btn
                      color="white"
                      dark small outline
                      class="text-none"
                      v-on="{ ...tooltip, ...menu }"
                    >
                      <v-icon left class="mr-1" small>autorenew</v-icon>
                      {{currentCurrencyName}} / {{currencyDimensionName}}
                    </v-btn>
                  </template>
                  <span>{{'TOOLTIP_CURRENCY' | translate}}</span>
                </v-tooltip>
              </template>
              <v-card max-width="326px" flat>
                <v-card-title class="pt-2" style="background-color: #004884; color:white;height: 34px">
                  {{'TITLE_DIM_SELECTION' | translate}}
                </v-card-title>
                <v-layout wrap justify-center align-center>
                  <v-card class="mt-4" flat>
                    <v-layout wrap justify-center align-center class="px-4">
                      <v-flex xs12>
                        <v-select
                          solo
                          dense
                          item-text="title"
                          item-value="id"
                          v-model="select_currency"
                          :items="itemscurrency"
                          :label="label_select_currency"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          solo
                          dense
                          item-text="name"
                          item-value="id"
                          v-model="select_currency_dimension"
                          :items="itemscurrencydimension"
                          :label="label_select_currency_dimension"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn block small dark color="#004884" class="text-none" @click="updateDimension()">{{'BUTT_OK'
                          | translate}}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-layout>
              </v-card>
            </v-menu>
          </div>
          <div>
            <v-btn @click="changeWA" dark small outline
                   class="text-none hidden-md-and-down" v-if="!isPeergroup">
              {{'BUTT_CHANGE_WA' | translate}}
            </v-btn>

            <v-btn @click="addAnchor" dark small outline
                   class="text-none hidden-md-and-down" v-if="!isPeergroup && hasWA">
              {{'BUTT_TAKE_ANCHORBANK' | translate}}
            </v-btn>

            <v-btn @click="editPeergroup" dark small outline
                   class="text-none hidden-md-and-down" v-if="isPeergroup">
              {{'BUTT_TAKE_PEERGROUP' | translate}}
            </v-btn>
            <v-btn @click="showSavePeergroupDialog" dark small outline
                   class="text-none hidden-md-and-down" v-if="isPeergroup">
              {{'BUTT_SAVE_PEERGROUP' | translate}}
            </v-btn>
            <v-btn @click="closePeergroup" dark small outline
                   class="text-none hidden-md-and-down" v-if="isPeergroup">
              {{'BUTT_CLOSE_PEERGROUP' | translate}}
            </v-btn>
          </div>

          <!--<v-btn @click="closePeergroup" dark small outline class="text-none hidden-md-and-down" v-if="isPeergroup">{{'BUTT_CLOSE_PEERGROUP' | translate}}</v-btn>-->
          <!--
          <BtnDownloadExcel :balance="balance" :data="data" :configExcel="configExcel" :name="configExcel.btnName"></BtnDownloadExcel>
          -->
          <v-tab-item v-for="(tab,i)  in tabsArray" v-bind:key="i" :value="tab.id">
            <TabStammDaten v-if="tab.id === 'STAMMDATEN' && tab.active === 1" :balanceArray="balanceArray"
                           :isBank="isBank" :isPeergroup="isPeergroup" :ref="tab.id" :data="data"
                           :balance="balance"></TabStammDaten>
            <TabRohbilanz v-if="tab.id === 'ROHBILANZ' && tab.active === 1" :balanceArray="balanceArray"
                          :isBank="isBank" :isPeergroup="isPeergroup" :ref="tab.id" :data="data"
                          :balance="balance"></TabRohbilanz>
            <TabStrukturBilanz v-if="tab.id === 'STRUKTURBILANZ' && tab.active === 1" :balanceArray="balanceArray"
                               :isBank="isBank" :isPeergroup="isPeergroup" :ref="tab.id" :data="data"
                               :balance="balance"></TabStrukturBilanz>
            <TabKennzahlen v-if="tab.id === 'KENNZAHLEN' && tab.active === 1" :balanceArray="balanceArray"
                           :isBank="isBank" :isPeergroup="isPeergroup" :ref="tab.id" :data="data"
                           :balance="balance"></TabKennzahlen>
            <!-- || (true)) -->
            <TabBankenscore v-if="tab.id === 'BANKENSCORE' && ((tab.active === 1))" :balanceArray="balanceArray"
                            :isBank="isBank" :isPeergroup="isPeergroup" :ref="tab.id" :data="data"
                            :balance="balance"></TabBankenscore>
            <TabBilko v-if="tab.id === 'BILKO' && ((tab.active === 1)) && balance" :balanceArray="balanceArray"
                            :isBank="isBank" :isPeergroup="isPeergroup" :ref="tab.id" :data="data"
                            :balance="balance"></TabBilko>
            <TabBRKommentar v-if="tab.id === 'BILKO' && ((tab.active === 1))" :balanceArray="balanceArray"
                      :isBank="isBank" :isPeergroup="isPeergroup" :ref="tab.id" :data="data"
                      :balance="balance"></TabBRKommentar>
            <TabVerflechtung v-if="tab.id === 'KONZERNVERBUND' && tab.active === 1" :balanceArray="balanceArray"
                             :isBank="isBank" :isPeergroup="isPeergroup" :ref="tab.id" :data="data"
                             :sdTitle="sdTitle"
                             :balance="balance"></TabVerflechtung>
            <TabDokumente v-if="tab.id === 'DOKUMENTE' && tab.active === 1" :balanceArray="balanceArray"
                          :isBank="isBank" :isPeergroup="isPeergroup" :ref="tab.id" :data="data"
                          :sdTitle="sdTitle"
                          :tabData="tabsArray"
                          :balance="balance"></TabDokumente>
            <TabKDF v-if="tab.id === 'KDF' && tab.active === 1" :balanceArray="balanceArray" :isBank="isBank"
                    :isPeergroup="isPeergroup" :ref="tab.id" :data="data" :balance="balance"></TabKDF>
            <TabBilanzrating v-if="tab.id === 'BILANZRATING' && ((tab.active === 1))" :balanceArray="balanceArray"
                             :isBank="isBank" :isPeergroup="isPeergroup" :ref="tab.id" :data="data"
                             :balance="balance"></TabBilanzrating>
          </v-tab-item>

          <!--
          <v-tab-item value="tabStammdaten">
            <TabStammDaten :balanceArray="balanceArray" :isPeergroup="isPeergroup" ref="tabStammdaten" :data="data"
                           :balance="balance"></TabStammDaten>
          </v-tab-item>
          <v-tab-item value="tabStrukturbilanz">
            <TabStrukturBilanz :balanceArray="balanceArray" :isPeergroup="isPeergroup" ref="tabStrukturbilanz"
                               tableName="aktiva" :balance="balance"></TabStrukturBilanz>
          </v-tab-item>
          <v-tab-item v-if="showRohbilanz" value="tabRohbilanz">
            <TabRohbilanz ref="tabRohbilanz" :data="data" :balance="balance"></TabRohbilanz>
          </v-tab-item>
          <v-tab-item value="tabKennzahlen">
            <TabKennzahlen :balanceArray="balanceArray" :isPeergroup="isPeergroup" ref="tabKennzahlen" :data="data"
                           :balance="balance"></TabKennzahlen>
          </v-tab-item>
          <v-tab-item value="tabBankScore">
            <TabBankenscore :balanceArray="balanceArray" ref="tabBankScore" :isPeergroup="isPeergroup"
                            :balance="balance" :data="data"></TabBankenscore>
          </v-tab-item>
          <v-tab-item value="tabVerflechtung">
            <TabVerflechtung :balanceArray="balanceArray" ref="tabVerflechtung" :isPeergroup="isPeergroup"
                             :balance="balance" :data="data"></TabVerflechtung>
          </v-tab-item>
          <v-tab-item value="tabKDF" v-if="!isBank">
            <TabKDF v-if="showKDF" :balanceArray="balanceArray" :isPeergroup="isPeergroup" ref="tabKDF" :data="data"
                    :balance="balance"></TabKDF>
          </v-tab-item>
          <v-tab-item v-if="showBilanzrating" value="tabBilanzrating">
            <TabBilanzrating :balanceArray="balanceArray" :isPeergroup="isPeergroup" ref="tabBilanzrating" :data="data"
                             :balance="balance"></TabBilanzrating>
          </v-tab-item>

          <v-tab-item value="tabDocuments">
            <TabDokumente :balanceArray="balanceArray" ref="tabDocuments" :isPeergroup="isPeergroup" :balance="balance"
                          :data="data" :isBank="isBank" :sdTitle="sdTitle"></TabDokumente>
          </v-tab-item>
          -->
        </v-tabs>
      </v-flex>
    </v-layout>

    <v-card flat>
      <DialogSaveItem ref="dlgSave" @doItem="savePeegroup" v-if="isPeergroup"></DialogSaveItem>
      <DialogOpenLink ref="dlgOpenLink" @doDialogOpenlink="doDialogOpenlink" v-if="isPeergroup"></DialogOpenLink>
    </v-card>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import DF from 'dateformat'
  import mock from '../../mockStructure.json'
  import FixedTableIE from './../tables/EasyTableIE'
  import MockupTab02 from './mockups/MockupSB01.vue'
  import MockupTab03 from './mockups/MockupRB01.vue'
  import MockupTabDocuments from './mockups/MockTabDocuments.vue'
  import TabStammDaten from './akte/TabStammDaten.vue'
  import TabRohbilanz from './akte/TabRohbilanz.vue'
  import TabStrukturBilanz from './akte/TabStrukturBilanz'
  import TabKennzahlen from './akte/TabKennzahlen'
  import TabBilanzrating from './akte/TabBilanzrating'
  import TabBankenscore from './akte/TabBankenscore'
  import TabBilko from './akte/TabBilko'
  import TabBRKommentar from './akte/TabBRKommentar'
  import TabKDF from './akte/TabKDF'
  import TabDokumente from './akte/TabDokumente'
  import DialogKonfigurationRows from './dialogs/DialogKonfigurationRows'
  import BtnDownloadExcel from './../widgets/BtnDownloadExcel'
  import ButtonDownloadIcon from './../widgets/BtnDownloadIcon'
  import TabVerflechtung from "./akte/TabVerflechtung";
  import BtnSupport from "../widgets/BtnSupport";
  import BtnSupportJahresabschluss from "../widgets/BtnSupportJahresabschluss";
  import DialogSaveItem from './../module/dialogs/DialogSaveItem'
  import DialogOpenLink from './../module/dialogs/DialogOpenLink'
  import DialogKennzahlen from "./dialogs/DialogKennzahlen";

  export default {
    name: 'StructureData',
    components: {
      DialogKennzahlen,
      DialogSaveItem,
      BtnSupport,
      DialogOpenLink,
      TabVerflechtung,
      TabBilko,
      TabBRKommentar,
      DialogKonfigurationRows,
      TabKennzahlen,
      TabBankenscore,
      TabDokumente,
      TabBilanzrating,
      TabKDF,
      TabStrukturBilanz,
      FixedTableIE,
      MockupTab02,
      MockupTab03,
      MockupTabDocuments,
      TabStammDaten,
      TabRohbilanz,
      BtnDownloadExcel,
      ButtonDownloadIcon,
      BtnSupportJahresabschluss
    },
    data() {
      return {
        tab: null,
        tabsArray: [],
        structureInfo: {},
        idModuleName: '',
        currentItem: 'tab-Web',
        select_currency: '2',
        itemscurrency: [],
        select_currency_dimension: '2',
        itemscurrencydimension: [],
        isBank: false,
        search: '',
        hasWA: false,
        label_select_currency_dimension: Vue.i18n.translate('CURRENCY_DIMENSION'),
        label_select_currency: Vue.i18n.translate('CURRENCY'),
        fnStammDaten: Vue.i18n.translate('TAB_STAMMDATEN'),
        fnStrukturBilanz: Vue.i18n.translate('TAB_STRUKTURBILANZ'),
        fnRohBilanz: Vue.i18n.translate('TAB_ROHBILANZ'),
        fnKennzahlen: Vue.i18n.translate('TAB_KENNZAHLEN'),
        fnBS: Vue.i18n.translate('TAB_BANKSCORE'),
        fnVP: Vue.i18n.translate('TAB_VERFLECHTUNG_DOWNLOAD'),
        fnKDF: Vue.i18n.translate('TAB_KAPITALDIENSTFAEHIGKEIT'),
        fnBilanzRating: Vue.i18n.translate('TAB_BILANZRATING'),

        tabData: {
          'STAMMDATEN': {
            downloadFile: Vue.i18n.translate('TAB_STAMMDATEN'),
            excel: {
              excelSheetStammdaten: 1,
              excelSheetStrukturbilanz: 0,
              excelSheetRohbilanz: 0,
              excelSheetKennzahlen: 0,
              excelSheetBilanzrating: 0,
              excelSheetKDF: 0,
              configName: '',
              btnName: Vue.i18n.translate('DOWNLOAD_NAME_SD'),
              name: '',
              type: 'EXCEL-STRUCT'
            }
          },
          'ROHBILANZ': {
            downloadFile: Vue.i18n.translate('TAB_ROHBILANZ'),
            excel: {
              excelSheetStammdaten: 0,
              excelSheetStrukturbilanz: 0,
              excelSheetRohbilanz: 1,
              excelSheetKennzahlen: 0,
              excelSheetBilanzrating: 0,
              excelSheetKDF: 0,
              configName: 'RB',
              btnName: Vue.i18n.translate('DOWNLOAD_NAME_RB'),
              type: 'EXCEL-STRUCT'
            }
          },
          'STRUKTURBILANZ': {
            downloadFile: Vue.i18n.translate('TAB_STRUKTURBILANZ'),
            excel: {
              excelSheetStammdaten: 0,
              excelSheetStrukturbilanz: 1,
              excelSheetRohbilanz: 0,
              excelSheetKennzahlen: 0,
              excelSheetBilanzrating: 0,
              excelSheetKDF: 0,
              btnName: Vue.i18n.translate('DOWNLOAD_NAME_SB'),
              configName: 'SB',
              name: '',
              type: 'EXCEL-STRUCT'
            }
          },
          'KENNZAHLEN': {
            downloadFile: Vue.i18n.translate('TAB_KENNZAHLEN'),
            excel: {
              excelSheetStammdaten: 0,
              excelSheetStrukturbilanz: 0,
              excelSheetRohbilanz: 0,
              excelSheetKennzahlen: 1,
              excelSheetBilanzrating: 0,
              excelSheetKDF: 0,
              btnName: Vue.i18n.translate('DOWNLOAD_NAME_KZ'),
              configName: 'KZ',
              name: '',
              type: 'EXCEL-STRUCT'
            }
          },
          'BANKENSCORE': {
            downloadFile: Vue.i18n.translate('TAB_BANKSCORE'),
            excel: {
              excelSheetStammdaten: 0,
              excelSheetStrukturbilanz: 0,
              excelSheetRohbilanz: 0,
              excelSheetKennzahlen: 0,
              excelSheetBilanzrating: 0,
              excelSheetKDF: 0,
              excelSheetBankscore: 1,
              excelSheetVerflechtung: 0,
              btnName: Vue.i18n.translate('DOWNLOAD_NAME_BS'),
              configName: 'BS',
              name: '',
              type: 'EXCEL-STRUCT'
            }
          },
          'KONZERNVERBUND': {
            downloadFile: Vue.i18n.translate('TAB_VERFLECHTUNG_DOWNLOAD'),
            excel: {
              excelSheetVerflechtung: 1,
              excelSheetKDF: 0,
              btnName: Vue.i18n.translate('DOWNLOAD_NAME_VP'),
              configName: 'KB',
              name: '',
              type: 'EXCEL-STRUCT'
            }
          },
          'DOKUMENTE': {
            downloadFile: null
          },
          'KDF': {
            downloadFile: Vue.i18n.translate('TAB_KAPITALDIENSTFAEHIGKEIT'),
            excel: {
              excelSheetStammdaten: 0,
              excelSheetStrukturbilanz: 0,
              excelSheetRohbilanz: 0,
              excelSheetKennzahlen: 0,
              excelSheetBilanzrating: 0,
              excelSheetKDF: 1,
              configName: 'KF',
              btnName: Vue.i18n.translate('DOWNLOAD_NAME_KDF'),
              name: '',
              type: 'EXCEL-STRUCT'
            }
          },
          'BILKO': {
            downloadFile: '',
            excel: {
              isHidden: true
            }
          },
          'BILANZRATING': {
            downloadFile: Vue.i18n.translate('TAB_BILANZRATING'),
            excel: {
              excelSheetStammdaten: 0,
              excelSheetStrukturbilanz: 0,
              excelSheetRohbilanz: 0,
              excelSheetKennzahlen: 0,
              excelSheetBilanzrating: 1,
              excelSheetKDF: 0,
              configName: 'BR',
              btnName: Vue.i18n.translate('DOWNLOAD_NAME_BR'),
              name: '',
              type: 'EXCEL-STRUCT'
            }
          }
        },
        reqData: null,
        data: null,
        correctCount: -1,
        ttData1: {},
        dimMenu: false,
        dimMenu1: false,
        ttData2: {},
        sdTitle: '',
        balanceArray: null,
        isFavoriteActive: true,
        showSZInfo: false,
        isPeergroup: false,
        appendAllowed: false,
        isAlertActivated: false,
        balance: null,
        tab1: null,
        tab2: null,
        showTabs: false,
        lastTab: null,
        isAlertActivatedText: Vue.i18n.translate('LABEL_ALERT_ACTIVATED'),
        headersSA: [
          {
            text: 'Name',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Wert',
            align: 'left',
            sortable: false,
            value: 'value'
          }],
        itemsSA: [{
          'name': 'Name',
          'value': 'Depfa Bank PLC'
        },
          {
            'name': 'CrefoNr',
            'value': '400986116'
          },
          {
            'name': 'Abschlussart',
            'value': 'Konzernab.'
          }],
        items: [
          'Stammdaten', 'Strukturbilanz', 'Rohbilanz', 'Kennzahlen', 'Kapitaldienstfähigkeit', 'Bilanzrating', 'Dokumente', 'Weitere'
        ],
        more: [],
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        link: '',
        idModule: '',
        idModuleItem: '',
        showRohbilanz: true,
        kdfDisabled: false,
        brDisabled: false,
        showBilanzrating: true,
        showKDF: true,
        pgresults: [],
        bankAnchor: null,
        currentCurrency: '1',
        currencyDimension: '1',
        currencyDimensionName: '',
        currentCurrencyName: '',
        selected: null,
        tableNotComplete: false,
        headers: [],
        'tableConfig': {
          selection: false,
          header: {
            columnClass: 'verlauf abstandunten04 theme--light blue tableIEPadding1'
          },
          rows: {
            rowClass: 'rowEIE'
          }
        }
      }
    },
    methods: {
      doDialogOpenlink() {
        this.$router.push('/Dashboard')

      },
      closePeergroup() {
        // console.log('closePeergroup')
        this.$refs.dlgOpenLink.open({
          name: 'Un',
          company: null
        })
      },
      showSavePeergroupDialog() {
        this.$refs.dlgSave.open()
      },
      savePeegroup(maskData) {
        var balances = []
        for (var index in this.balanceArray) {
          var item = this.balanceArray[index]
          balances.push(Vue.prototype.$api.balanceToString(item))
        }
        var pg = {
          name: maskData.name,
          balances: balances
        }
        if (Vue.prototype.storage.hasAnkerBank) {
          pg.company = Vue.prototype.$api.balanceToString(Vue.prototype.storage.ankerBankBalance)
        }
        Vue.prototype.$api.savePeergroup(pg, this.onSaveDone)
        Vue.prototype.$api.debug('savePeegroup',)
      },
      onSaveDone() {
        // console.log('onSaveDone')
      },
      destroTable() {
        var item = this.tab1
        if (this.$refs[item] && this.$refs[item].close) {
          this.$refs[item].close()
        }
      },
      onChangeTab(item) {
        let tabCmp = null
        if (this.$refs[item]) {
          tabCmp = this.$refs[item][0]
        } else {
          console.error('Missing tab', item, this.$refs)
          return
        }
        Vue.prototype.$api.debug('onChangeTab', item, this.lastTab, tabCmp)
        if (this.lastTab) {
          if (tabCmp && tabCmp.close) {
            tabCmp.close()
          }
        }
        if (tabCmp && tabCmp.open) {
          tabCmp.open(this.data)
        }
        this.lastTab = item
      },
      addItem(item) {
        const removed = this.items.splice(0, 1)
        this.items.push(
          ...this.more.splice(this.more.indexOf(item), 1)
        )
        this.more.push(...removed)
        this.$nextTick(() => {
          this.currentItem = 'tab-' + item
        })
      },
      getFileName: function (v) {
        if (this.balance) {
          var title = v + '_' + this.balance.crefoNr + '_'
          var today = new Date();
          var dStr = DF(today, 'yyyymmdd')
          return title + dStr
        } else {
          var today = new Date();
          var dStr = DF(today, 'yyyymmdd')
          return title + dStr
        }
      },
      test: function () {
        console.log('test', this.$refs)
        this.$refs.dlgKennzahlen.open()
      },
      onKZFButton (data) {
        console.log('onKZFButton', this.currentItem, this.data)
        let balance = this.currentItem.balance
        let hideValue = false
        if (data.head.meta.type === 'year') {
          let company = this.data.company
          let curIndex = _.findIndex(company.balanceHistory, function (o) {
            return data.head.meta.title === o.year
          })
          if (curIndex > -1) {
            balance = this.data.company.balanceHistory[curIndex]
          }
        } else if (data.head.meta.type === 'title') {
          hideValue = true
        }
        console.log('dlgKennzahlen', data.type, data.id, balance)
        this.$refs.dlgKennzahlen.open(data.type, data.id, balance, hideValue)
      },
      openFirstTab: function () {
        var cmp = this

        this.$nextTick(() => {
          cmp.showSelect = true
          // cmp.$refs['tabStammdaten'].open(this.balance)
          // $('div[name=sdTabPanel]').find('a').first().css('position', 'static') // removed on 6.4
          // $('div[name=sdTabPanel]').find('a').first().addClass('v-tabs__item--active')
          // $('div[name=sdTabPanel]').find('.v-tabs__slider-wrapper').first().css('width', 158)
        })

        this.tab1 = 'STAMMDATEN'
        this.reloadTab()

        // cmp.$refs['tabStammdaten'].onGetData(this.data)// removed on 6.4

      },
      doSetNotification: function () {
        Vue.prototype.$api.debug('doSetNotification', this.isAlertActivated, this.balance)
        this.isAlertActivated = !this.isAlertActivated
        Vue.prototype.$api.showIdle()
        Vue.prototype.$api.setAlertFunction(this, this.balance.crefoNr, this.isAlertActivated, this.onSetNotificationDone, this.onSetNotificationDone)
      },
      onSetNotificationDone(data) {
        Vue.prototype.$api.debug('onSetNotificationDone', data)
        Vue.prototype.$api.hideIdle()
      },
      onGetFavourite(favData) {
        Vue.prototype.$api.debug('onGetFavourite', favData)

        if (favData.simpleAnswer === '1') {
          this.isAlertActivated = true
        } else {
          this.isAlertActivated = false
        }
      },
      checkIsFavourite(crefoNr) {
        Vue.prototype.$api.isFavouriteActive(crefoNr, this.onGetFavourite)
      },
      updateCurrency(curData) {
        console.log('itemscurrency', this.itemscurrency, curData)
        if (!curData) return
        if (curData.currencyNr) {
          this.currentCurrency = curData.currencyNr * 1
        }
        if (curData.currencyDimensionNr && curData.currencyDimensionNr != '0') {
          this.currencyDimension = curData.currencyDimensionNr * 1
        }
        Vue.prototype.storage.setDimension(this.currentCurrency, this.currencyDimension)
        this.currentCurrencyName = Vue.prototype.$api.getI18NCurrency(Vue.prototype.storage.getCurrency()).name

        this.select_currency_dimension = '' + this.currencyDimension
        var cDim = Vue.prototype.$api.getI18NCurrencyDimension(Vue.prototype.storage.getCurrencyDimension())
        this.currencyDimensionName = cDim.name
        Vue.prototype.$api.debug('Currency', this.currencyDimensionName, this.currentCurrencyName, this.currentCurrency)
        /*
        Vue.prototype.$eventHub.$emit('changeCurrency', {
          currency: this.currentCurrency,
          dimension: this.select_currency_dimension,
          currencyName: this.currentCurrencyName,
          dimensionName: this.currencyDimensionName
        })
        */

        // cmp.itemscurrency = Vue.prototype.storage.getCurrencyList()
        // cmp.itemscurrencydimension = Vue.prototype.storage.getCurrencyDimensionList()

        this.itemscurrency = Vue.prototype.storage.getCurrencyListFiltered(this.currentCurrency)
        // update Select Box
        this.select_currency = '' + this.currentCurrency
        // cmp.itemscurrencydimension = Vue.prototype.storage.getCurrencyDimensionList()

        this.currentCurrency = Vue.prototype.storage.getCurrency()
        this.currentCurrencyName = Vue.prototype.$api.getI18NCurrency(this.currentCurrency).name
        this.currencyDimensionName = Vue.prototype.$api.getI18NCurrencyDimension(Vue.prototype.storage.getCurrencyDimension()).name

      },
      getCountBanks() {
        let reqData = {}
        reqData = Vue.prototype.$api.injectRequestData(reqData)
        reqData = Vue.prototype.$api.fillCompanyAndBalance(reqData)
        console.log('bounce', reqData)
        this.correctCount = -1
        try {
          let pgStr = ''
          if (reqData.company) {
            pgStr = pgStr + reqData.company +','
          }
          pgStr = pgStr + reqData.peergroup
          let arr = pgStr.split(',')
          let map = {}
          for (var i = 0; i < arr.length; i++) {
            map[arr[i]] = true
          }
          this.correctCount = Object.keys(map).length
        } catch (eee) {
          console.error(eee)
        }
        console.log('bounce correctCount', this.correctCount)
        if (this.correctCount !== -1) {
          return this.correctCount
        } else {
          var cnt = 1
          if (this.structureInfo.peerCount) {
            cnt = this.structureInfo.peerCount
          }
          if (Vue.prototype.storage.isAnkerbank(Vue.prototype.$api.getModuleId())) {
            cnt = cnt + 1
          }
          return cnt
        }
      },
      onGetData(allData) {
        // console.log('allData', allData)
        var cmp = this
        this.data = allData
        this.headers = []

        Vue.prototype.$api.hideIdle()
        if (!this.isPeergroup) {
          this.checkIsFavourite(this.balance.crefoNr)
        }

        // window.setTimeout(this.openFirstTab, 100)
        /*
        var data = allData.tables.aktiva
        Vue.prototype.$api.debug(data)
        for (var index in data.columns) {
          var item = data.columns[index]
          this.headers.push({
            text: item.title,
            value: index,
            isExtraField: false,
            columnClass: 'col' + this.headers.length + 1,
            index: this.headers.length + 1,
            id: this.headers.length + 1,
            isVisible: true,
            sortable: true
          })
        }
        this.pgresults = []
        for (var index in data.rows) {
          var cells = data.rows[index].cells
          this.pgresults.push(cells)
        }
        */
        /*
        if (this.$refs.sdTable && this.$refs.sdTable.updateData) {
          this.$refs.sdTable.updateData(this.pgresults)
        }
        */
      },
      createQuery() {
        var query = {}
        if (this.balance) {
          query.company = this.balance.crefoNr + ':' + this.balance.year + ':' + this.balance.aaNr + ':' + this.balance.rkNr + ':' + this.balance.source
        }
        if (this.isPeergroup) {
          query.company = ''
          query.peergroup = ''
          var arr = this.getBalanceArray()
          for (var index in arr) {
            var balance = arr[index]
            query.peergroup += balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source + ','
          }
          query.peergroup = query.peergroup.substr(0, query.peergroup.length - 1)
        }
        query.currency = Vue.prototype.storage.getCurrency()
        query.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
        this.currentCurrencyName = Vue.prototype.$api.getI18NCurrency(query.currency).name
        this.currencyDimensionName = Vue.prototype.$api.getI18NCurrencyDimension(Vue.prototype.storage.getCurrencyDimension()).name
        return query
      },
      loadData() {
        this.data = null
        Vue.prototype.$api.showIdle()
        if (this.balance) {
          if (this.balance.aaNr === '0') {
            if (!this.isPeergroup) {
              this.checkIsFavourite(this.balance.crefoNr)
            }
          }
        }
        var result = Vue.prototype.$api.createStructureData(this.createQuery(), this.onGetData)

        if (this.isPeergroup) {
          Vue.prototype.$api.getStammDataWithBalanceArray(this.balanceArray, true, this.onGetStammData)
        } else {
          Vue.prototype.$api.getStammDataWithBalance(this.balance, true, this.onGetStammData)
        }
      },
      onGetStammData(data) {
        this.updateCurrency(data.currencyData)
      },
      reloadTab() {
        var tab = this.$refs['' + this.tab1][0]
        // console.log('reloadTab', tab, this.tab1, this.$refs)
        if (tab) {
          // console.log('tab', tab)
          tab.reload()
        }
      },
      reloadTabCauseLocale() {
        let cmp = this
        window.setTimeout(function () {
          cmp.doMount()
          /*
          // console.log('reloadTabCauseLocale', cmp.tab1, cmp.$refs, cmp.$refs[cmp.tab1])
          var tab = cmp.$refs[cmp.tab1][0]
          if (tab && tab.reload) {
            tab.reload()
          } else {
            console.error('missing reload on', tab)
          }
          */
        }, 200)
      },
      OnGetExcelConfig(config) {
        this.configExcel = config
      },
      updateDimension() {
        Vue.prototype.$api.debug('updateDimension', this.select_currency, this.select_currency_dimension)
        this.dimMenu = false
        this.dimMenu1 = false
        this.resetDim()
      },
      resetDim() {
        Vue.prototype.$api.debug('resetDim', this.select_currency, this.select_currency_dimension)
        Vue.prototype.storage.setDimension(this.select_currency, this.select_currency_dimension)
        this.currentCurrency = this.select_currency
        this.currentCurrencyName = Vue.prototype.$api.getI18NCurrency(this.select_currency).name
        this.currencyDimensionName = Vue.prototype.$api.getI18NCurrencyDimension(Vue.prototype.storage.getCurrencyDimension()).name
        /*
        Vue.prototype.$eventHub.$emit('changeCurrency', {
          currency: this.currentCurrency,
          dimension: this.select_currency_dimension,
          currencyName: this.currentCurrencyName,
          dimensionName: this.currencyDimensionName
        })*/
        this.reloadTab()
      },
      getBalanceArray() {
        var cmp = this
        var arr = []
        var aaNr = this.$route.params.aaNr.split(',')
        var crefoNr = this.$route.params.crefoNr.split(',')
        var rkNr = this.$route.params.rkNr.split(',')
        var source = this.$route.params.source.split(',')
        var year = this.$route.params.year.split(',')

        for (var index in aaNr) {
          var balance = {
            aaNr: aaNr[index],
            crefoNr: crefoNr[index],
            rkNr: rkNr[index],
            source: source[index],
            year: year[index]
          }
          balance.crefoNr = balance.crefoNr.replace('_', '#')
          arr.push(balance)
        }
        return arr
      },
      changeWA() {
        var item = {
          meta: this.balance,
          tableConfig: {
            idModule: this.idModule,
            tableName: this.idModule
          }
        }
        Vue.prototype.$api.debug('changeWA', item)
        Vue.prototype.$eventHub.$emit('openOSItem', item)
      },
      editPeergroup() {
        this.$router.push('/di/peergroup/' + Vue.prototype.$api.getModuleId() + '/overview')
      },
      OnGetHasWA(d) {
        this.hasWA = d
      },
      getTabInformations() {
        Vue.prototype.$api.debug('reload', this.balance)
        Vue.prototype.$api.showIdle()
        this.groups = []
        // getTabInformations(isPeergroup, arr, balance, fnSuccess, fnError) {
        Vue.prototype.$api.getTabInformations(this.isPeergroup, this.balanceArray, this.balance, this.onGetTabInformations)
      },
      onGetTabInformations(data) {
        var cmp = this
        let firstTab = null
        this.structureInfo = data
        this.tabsArray = data.reiterArray
        // Create Akten Title
        this.sdTitle = ''
        if (this.isPeergroup) {
          this.sdTitle += this.structureInfo.companyTitle + ' ' + this.structureInfo.peergroupTitle + ' (' + (this.getCountBanks()) + ' ' + Vue.i18n.translate('TITLE_PEERGROUP_INSTITUTES_' + this.idModule.toUpperCase()) + ')'
        } else {
          this.sdTitle = this.structureInfo.companyTitle
        }
        if (!this.sdTitle) {
          this.sdTitle = ''
        }
        // Create Akten Title ende

        _.forEach(this.tabsArray, function (tab) {
          let tabData = cmp.tabData['' + tab.id]
          const initialTooltip = tab.tooltip
          console.log('initialTooltip', initialTooltip, tab)
          tab.tooltip = tab.name
          if (tabData) {
            tab.downloadFileName = tabData.downloadFile
            tab.excel = tabData.excel
            tab.on = {}
            if (tab.excel) {
              tab.excel.isPeergroup = cmp.isPeergroup
              tab.excel.balanceArray = cmp.getBalanceArray()
            } else {
              console.log('missing excel', tab)
            }
            tab.tooltip = tab.name
            if (tab.active === 0) {
              if (tab.id === 'BILANZRATING') {
                tab.tooltip = initialTooltip
              } else {
                tab.tooltip = Vue.i18n.translate('TAB_DISABLED_CAUSE_NO_DATA')
              }
            }
            if (tab.active === 1) {
              if (tab.id === 'BILKO') {
                tab.tooltip = tab.name
                if (Vue.prototype.$api.getModuleId() === 'banks' && Vue.prototype.$api.hasProduct('bilkoBank')) {
                  tab.active = 1
                  tab.tooltip = ''
                } else if (Vue.prototype.$api.getModuleId() === 'companies' && Vue.prototype.$api.hasProduct('bilko')) {
                  tab.active = 1
                  tab.tooltip = ''
                } else {
                  tab.tooltip = Vue.i18n.translate('TAB_DISABLED_CAUSE_NO_LICENSE')
                }
              } else if (tab.id === 'KDF') {
                tab.active = 0
                if (Vue.prototype.$api.hasProduct('kdf')) {
                  tab.active = 1
                } else {
                  tab.tooltip = Vue.i18n.translate('TAB_DISABLED_CAUSE_NO_LICENSE')
                }
              } else if (tab.id === 'KONZERNVERBUND') {
                if (Vue.prototype.$api.getModuleId() === 'banks') {
                  tab.excel.excelSheetVerflechtungHierarchisch = 1
                }
              } else if (tab.id === 'BILANZRATING') {
                tab.active = 0
                if (Vue.prototype.$api.hasProduct('balanceRating')) {
                  tab.active = 1
                } else {
                  // tab.tooltip = Vue.i18n.translate('TAB_DISABLED_CAUSE_NO_LICENSE')
                  tab.tooltip = tab.tooltip
                }
              }
            } else {
              // // TAB_DISABLED_CAUSE_NO_BALANCE
            }
            // cmp.kdfDisabled = !Vue.prototype.$api.hasProduct('kdf')
            // cmp.brDisabled = !Vue.prototype.$api.hasProduct('balanceRating')
          }
          if (tab.selected) {
            cmp.tab1 = tab.id
            firstTab = tab
          }
          console.log('tab', tab)
        })
        cmp.loadData()
        // this.$nextTick(this.reloadTab)
        window.setTimeout(function () {
          if (firstTab !== null) {
            cmp.onChangeTab(firstTab.id)
          }
        }, 400)
      },
      addAnchor() {
        let cmp = this
        Vue.prototype.$api.debug('addAnchor', this.balance)
        Vue.prototype.$api.clearGroupData(this.balance, this.data)
        Vue.prototype.storage.setAnkerbank(Vue.prototype.$api.getModuleId(), this.balance)
        Vue.prototype.storage.setAnkerbankData(Vue.prototype.$api.getModuleId(), {
          title: cmp.sdTitle,
          balance: cmp.balance
        })
        this.$router.push(Vue.prototype.$api.getPeegroupSearchUrl(this.idModule, this.balance))
      },
      doMount() {
        if (window.location.href.indexOf('StructureDataAnchor') > -1) {
          Vue.prototype.storage.resetPeergroup(Vue.prototype.$api.getModuleId())
        }
        this.appendAllowed = Vue.prototype.$api.isModuleConfigSet('APPEND_BALANCE')
        this.idModuleName = Vue.i18n.translate(this.idModule.toUpperCase() + '_TITLE')
        Vue.prototype.$api.debug('Module StructureData', this.$route.params, mock)
        var cmp = this
        Vue.prototype.storage.setConfigName('')
        cmp.itemscurrency = Vue.prototype.storage.getCurrencyList()
        cmp.itemscurrencydimension = Vue.prototype.storage.getCurrencyDimensionList()
        cmp.idModule = Vue.prototype.$api.getModuleId()
        cmp.idModuleItem = cmp.$route.params.idModuleItem
        cmp.link = '/di/StructureData/' + Vue.prototype.$api.getModuleId()
        cmp.isBank = cmp.idModule === 'banks'
        cmp.balance = {
          aaNr: cmp.$route.params.aaNr,
          crefoNr: cmp.$route.params.crefoNr,
          rkNr: cmp.$route.params.rkNr,
          source: cmp.$route.params.source,
          year: cmp.$route.params.year,
        }
        Vue.prototype.$api.checkCredentials(cmp, function () {
          cmp.pgresults = []
          cmp.reqData = []
          if (cmp.$route.params.balance) {
            cmp.balance = cmp.$route.params.balance
          } else {
            cmp.balanceArray = Vue.prototype.storage.getPeergroup(Vue.prototype.$api.getModuleId())
            cmp.isPeergroup = Vue.prototype.storage.isPeergroup(Vue.prototype.$api.getModuleId())
            cmp.kdfDisabled = !Vue.prototype.$api.hasProduct('kdf')
            cmp.brDisabled = !Vue.prototype.$api.hasProduct('balanceRating')

            if (cmp.isPeergroup) {
              cmp.balance = cmp.balanceArray[0]
              cmp.isFavoriteActive = false

              Vue.prototype.$api.getBreadCrumpModule(cmp.idModule, {
                id: 'Peegroup',
                text: 'Peergroup Suche',
                disabled: false,
                href: '/#/di/peergroup/' + cmp.idModule
              }, {
                id: 'Peegroup bearbeiten',
                text: 'Peergroup bearbeiten',
                disabled: false,
                href: '/#/di/peergroup/' + cmp.idModule + '/overview'
              })
            } else {
              Vue.prototype.$api.getBreadCrumpModule(cmp.idModule, {
                id: 'Ankerbanksuche',
                text: 'Suche',
                disabled: false,
                href: '/#/di/search/' + cmp.idModule
              })
              cmp.balance = {
                aaNr: cmp.$route.params.aaNr,
                crefoNr: cmp.$route.params.crefoNr,
                rkNr: cmp.$route.params.rkNr,
                source: cmp.$route.params.source,
                year: cmp.$route.params.year,
              }
            }
            cmp.balance.crefoNr = cmp.balance.crefoNr.replace('_', '#')

          }
          // query.currency = Vue.prototype.storage.getCurrency()
          // query.currencyDimension = Vue.prototype.storage.getCurrencyDimension()

          cmp.currentCurrency = Vue.prototype.storage.getCurrency()
          cmp.currentCurrencyName = Vue.prototype.$api.getI18NCurrency(cmp.currentCurrency).name
          cmp.currencyDimensionName = Vue.prototype.$api.getI18NCurrencyDimension(Vue.prototype.storage.getCurrencyDimension()).name

          cmp.showRohbilanz = !cmp.isPeergroup
          cmp.showBilanzrating = !cmp.isPeergroup && !cmp.isBank
          cmp.showKDF = !cmp.isPeergroup && !cmp.isBank
          cmp.currentCurrency = Vue.prototype.storage.getCurrency()
          cmp.currentCurrencyName = Vue.prototype.$api.getI18NCurrency(cmp.currentCurrency).name
          cmp.currencyDimensionName = Vue.prototype.$api.getI18NCurrencyDimension(Vue.prototype.storage.getCurrencyDimension()).name
          cmp.getTabInformations()

          // Vue.prototype.$eventHub.$emit('OnGetModuleTitle', 'Strukturdaten')
        })
      }
    },
    mounted() {
      this.doMount()
    },
    created() {
      Vue.prototype.$eventHub.$on('setLocale2', this.reloadTabCauseLocale)
      // Vue.prototype.$eventHub.$on('changeCurrency', this.reloadTab)
      Vue.prototype.$eventHub.$on('OnGetExcelConfig', this.OnGetExcelConfig)
      Vue.prototype.$eventHub.$on('hasWA', this.OnGetHasWA)
      Vue.prototype.$eventHub.$on('onKZFButton', this.onKZFButton)

    },
    destroyed() {
      Vue.prototype.$eventHub.$off('setLocale2', this.reloadTabCauseLocale)
      // Vue.prototype.$eventHub.$off('changeCurrency', this.reloadTab)
      Vue.prototype.$eventHub.$off('OnGetExcelConfig', this.OnGetExcelConfig)
      Vue.prototype.$eventHub.$off('hasWA', this.OnGetHasWA)
      Vue.prototype.$eventHub.$off('onKZFButton', this.onKZFButton)
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/StructureData.vue